<template>
  <div class="comments">
    <div v-if="comments">
      <CommentItem
        @submit="fetchComments"
        v-for="comment in comments"
        :key="'comment' + comment.id"
        :comment="comment"
      />
    </div>
  </div>
</template>
<script>
import CommentItem from "@/components/comment/CommentItem.vue";
import fetchApi from "@/mixins/fetchApi";
export default {
  components: { CommentItem },
  props: {
    recipe: { required: true }
  },
  data() {
    return { comments: false };
  },
  created() {
    this.fetchComments();
  },
  methods: {
    async fetchComments() {
      const response = await fetchApi.get("comments/recipe/" + this.recipe.id);
      this.comments = response.data;
    }
  }
};
</script>
